"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const context_1 = require("./context");
function createBufferInfoFromArrays(arrays) {
    const gl = context_1.getWebGLContext();
    const bufferInfo = {};
    for (let attribName in arrays) {
        const buffer = gl.createBuffer();
        if (buffer === null)
            throw new Error("unable to create buffer");
        bufferInfo[attribName] = {
            buffer: buffer,
            numComponents: arrays[attribName]["numComponents"]
        };
    }
    for (let attribName in bufferInfo) {
        gl.bindBuffer(gl.ARRAY_BUFFER, bufferInfo[attribName]["buffer"]);
        gl.bufferData(gl.ARRAY_BUFFER, arrays[attribName]["data"], gl.STATIC_DRAW);
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    return bufferInfo;
}
exports.createBufferInfoFromArrays = createBufferInfoFromArrays;
var computeBufferInfo;
function getComputeBufferInfo() {
    if (!computeBufferInfo)
        computeBufferInfo = createBufferInfoFromArrays({
            a_position: {
                data: new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
                numComponents: 2
            }
        });
    return computeBufferInfo;
}
exports.getComputeBufferInfo = getComputeBufferInfo;
//# sourceMappingURL=bufferInfo.js.map